import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import Container from '@material-ui/core/Container'
import RateReviewOutlinedIcon from '@material-ui/icons/RateReviewOutlined'
import { CoachReviewsQuery } from './query'
import CoachReviews from 'components/coach-reviews'
import AskForReviewsModal from 'components/coach-reviews-request'
import EmptyReviews from 'components/empty-page-state'
import Error from 'components/error'

const CoachReviewsView = () => {
  const { data, loading, error, refetch } = useQuery(CoachReviewsQuery)
  const [open, setOpen] = useState(false)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error />

  const coachReviews = get(data, 'GetCoachReviews.coachReviews', []) || []
  const coachProfile = get(coachReviews, '[0].coachProfile', []) || []

  const completedReviews = coachReviews
    .filter(review => review)
    .filter(({ status }) => status === 'COMPLETE')

  return (
    <>
      <Container>
        {completedReviews.length ? (
          <CoachReviews
            coachProfile={coachProfile}
            coachReviews={data.GetCoachReviews}
            open={open}
            setOpen={setOpen}
          />
        ) : (
          <EmptyReviews
            actionFn={() => setOpen(true)}
            IconComp={() => <RateReviewOutlinedIcon fontSize="large" />}
            title="Reviews"
            caption="Feedback from your students will appear here."
            buttonText="Ask for Reviews"
          />
        )}
      </Container>
      <AskForReviewsModal {...{ coachReviews, refetch, open, setOpen }} />
    </>
  )
}

export default CoachReviewsView
